import { onSubdomain } from '../../../common/routes/general';
import { Permission } from '../../../common/routes/types';
// True when the admin is acting across every community rather than inside one. Only the root host
// has them all in scope; a subdomain has already resolved to a single community, and that is the
// one staff administer there. Shared by the listing and the wizard so both agree on which
// endpoints to call — they have to, or a staff edit would save against the wrong scope.
export const isCrossCommunity = (hasPermission) => !onSubdomain && hasPermission([Permission.SystemDistricts]);
